import { Grid, rem } from "@mantine/core";
import { Select } from "src/components/shared/MantineCombobox";
import { Fragment } from "react";
import { StyledGridCol } from "src/components/pages/Summary/VerifyEntries/VerifyEntries.styled";
import { type ICheckList, type SetChecklist } from "src/interfaces";

import { useSelector } from "../../../redux/hooks";
import ChecklistListRow from "./ChecklistListRow";
import { checklistTypes, EChecklistType } from "./checklists.utils";
import { Flex } from "../../../styled";
import LocalSearch from "../../../components/shared/LocalSearch/LocalSearch";
import styles from "./ChecklistsModal.module.scss";

interface Props {
  data: ICheckList[] | undefined;
  defaultData: ICheckList[] | undefined;
  setSearchedData: (data: ICheckList[]) => void;
  setCheckList: SetChecklist;
  loading: boolean;
  currentLbid: string | undefined;
  refetch: () => void;
  disableCopy: boolean;
  checklistType: EChecklistType | null;
  setChecklistType: (type: EChecklistType) => void;
  resetSearch: number;
  setResetSearch: (resetSearch: number) => void;
}

const headers = [
  { label: "Name", colSpan: 8 },
  { label: "Version", colSpan: 1 },
  { label: "", colSpan: 2 },
];

const CheckListsList = ({
  data,
  checklistType,
  setChecklistType,
  setSearchedData,
  defaultData,
  resetSearch,
  setResetSearch,
  ...props
}: Props) => {
  const { areChecklistsDisabled } = useSelector(state => state.permsSlice);

  return (
    <Flex direction="column" gap={rem(20)}>
      <Flex gap={2} align="flex-end">
        {checklistType && (
          <Select
            value={checklistType}
            onChange={setChecklistType}
            label="Checklist Type"
            data={checklistTypes}
            w={200}
          />
        )}
        <LocalSearch
          setData={setSearchedData}
          defaultData={defaultData}
          searchByProperty="name"
          resetSearch={resetSearch}
          setResetSearch={setResetSearch}
        />
      </Flex>

      <Flex direction="column" className={styles.listSection}>
        <Grid align="center" className={styles.header}>
          {headers.map((c, i) => (
            <StyledGridCol
              span={c.colSpan}
              align="center"
              key={`checklist-header-${i}`}>
              {c.label}
            </StyledGridCol>
          ))}
        </Grid>
        <div className={styles.rowList}>
          {data && data.filter(c => !c.hidden).length > 0 ? (
            data.map(
              (c, i) =>
                !c.hidden && (
                  <ChecklistListRow
                    key={`checkist-lb-${i}`}
                    row={c}
                    disabled={areChecklistsDisabled}
                    {...props}
                  />
                ),
            )
          ) : (
            <div style={{ textAlign: "center" }}>
              {checklistType === EChecklistType.PROGRESS
                ? "There are no outstanding Checklists for completion"
                : "There are no matching checklists"}
            </div>
          )}
        </div>
      </Flex>
    </Flex>
  );
};

export default CheckListsList;
